export const japaneseSurnames = ['Sato', 'Suzuki', 'Takahashi', 'Tanaka', 'Watanabe', 'Ito', 'Yamamoto', 'Nakamura', 'Kobayashi', 'Kato'];
export const chineseSurnames = ['Wang', 'Li', 'Zhang', 'Liu', 'Chen', 'Yang', 'Huang', 'Zhao', 'Wu', 'Zhou'];
export const arabicSurnames = ['Al-Ahmad', 'Al-Hassan', 'Al-Ali', 'Al-Mohammed', 'Al-Ibrahim', 'Al-Khalil', 'Al-Omar', 'Al-Salem', 'Al-Rashid', 'Al-Nasser'];
export const portugueseSurnames = ['Silva', 'Santos', 'Oliveira', 'Souza', 'Rodrigues', 'Ferreira', 'Almeida', 'Pereira', 'Lima', 'Costa'];

export const japaneseSurnamePronunciation: Record<string, string> = {
  'Sato': '사토', 'Suzuki': '스즈키', 'Takahashi': '타카하시', 'Tanaka': '타나카', 'Watanabe': '와타나베',
  'Ito': '이토', 'Yamamoto': '야마모토', 'Nakamura': '나카무라', 'Kobayashi': '코바야시', 'Kato': '카토'
};
export const chineseSurnamePronunciation: Record<string, string> = {
  'Wang': '왕', 'Li': '리', 'Zhang': '장', 'Liu': '리우', 'Chen': '천',
  'Yang': '양', 'Huang': '황', 'Zhao': '자오', 'Wu': '우', 'Zhou': '저우'
};
export const arabicSurnamePronunciation: Record<string, string> = {
  'Al-Ahmad': '알아흐마드', 'Al-Hassan': '알하산', 'Al-Ali': '알알리', 'Al-Mohammed': '알무함마드', 'Al-Ibrahim': '알이브라힘',
  'Al-Khalil': '알칼릴', 'Al-Omar': '알오마르', 'Al-Salem': '알살렘', 'Al-Rashid': '알라시드', 'Al-Nasser': '알나세르'
};
export const portugueseSurnamePronunciation: Record<string, string> = {
  'Silva': '실바', 'Santos': '산투스', 'Oliveira': '올리베이라', 'Souza': '소우자', 'Rodrigues': '호드리게스',
  'Ferreira': '페헤이라', 'Almeida': '알메이다', 'Pereira': '페레이라', 'Lima': '리마', 'Costa': '코스타'
};

export const japaneseNamePronunciation: Record<string, Record<string, string>> = {
  male: {
    'Haruto': '하루토', 'Yuto': '유토', 'Sota': '소타', 'Kaito': '카이토',
    'Riku': '리쿠', 'Takumi': '타쿠미', 'Ren': '렌', 'Daiki': '다이키',
    'Yuki': '유키', 'Hayato': '하야토', 'Shota': '쇼타', 'Kenta': '켄타',
    'Ryota': '료타', 'Tatsuya': '타츠야', 'Kenji': '켄지', 'Hiroshi': '히로시',
    'Masato': '마사토', 'Naoki': '나오키', 'Shinji': '신지', 'Akira': '아키라'
  },
  female: {
    'Sakura': '사쿠라', 'Yui': '유이', 'Hina': '히나', 'Mio': '미오',
    'Aoi': '아오이', 'Rin': '린', 'Mei': '메이', 'Yuna': '유나',
    'Akari': '아카리', 'Nanami': '나나미', 'Ayaka': '아야카', 'Emi': '에미',
    'Haruka': '하루카', 'Kana': '카나', 'Miyu': '미유', 'Nana': '나나',
    'Riko': '리코', 'Saki': '사키', 'Yuki': '유키', 'Asuka': '아스카'
  }
};
export const chineseNamePronunciation: Record<string, Record<string, string>> = {
  male: {
    'Wei': '웨이', 'Chen': '천', 'Ming': '밍', 'Jun': '준',
    'Hao': '하오', 'Feng': '펑', 'Lei': '레이', 'Xin': '신',
    'Bo': '보', 'Cheng': '청', 'Dong': '동', 'Gang': '강',
    'Guang': '광', 'Hai': '하이', 'Jian': '지안', 'Kai': '카이',
    'Lin': '린', 'Long': '롱', 'Peng': '펑', 'Qiang': '치앙'
  },
  female: {
    'Mei': '메이', 'Ling': '링', 'Xiu': '슈', 'Yan': '옌',
    'Li': '리', 'Jing': '징', 'Fang': '팡', 'Hui': '후이',
    'Xia': '샤', 'Ying': '잉', 'Qing': '칭', 'Rong': '롱',
    'Shu': '슈', 'Wen': '원', 'Xin': '신', 'Yu': '위',
    'Zhen': '전', 'Ai': '아이', 'Bao': '바오', 'Chun': '춘'
  }
};
export const englishNamePronunciation: Record<string, Record<string, string>> = {
  male: {
    'James': '제임스', 'Michael': '마이클', 'David': '데이비드', 'John': '존',
    'Robert': '로버트', 'William': '윌리엄', 'Daniel': '대니얼', 'Matthew': '매튜',
    'Christopher': '크리스토퍼', 'Andrew': '앤드류', 'Joseph': '조셉', 'Ryan': '라이언',
    'Brandon': '브랜든', 'Jason': '제이슨', 'Justin': '저스틴', 'Kevin': '케빈',
    'Brian': '브라이언', 'Eric': '에릭', 'Steven': '스티븐', 'Timothy': '티모시'
  },
  female: {
    'Emily': '에밀리', 'Sarah': '세라', 'Jessica': '제시카', 'Ashley': '애슐리',
    'Jennifer': '제니퍼', 'Amanda': '아만다', 'Michelle': '미셸', 'Rachel': '레이첼',
    'Elizabeth': '엘리자베스', 'Megan': '메건', 'Lauren': '로렌', 'Stephanie': '스테파니',
    'Nicole': '니콜', 'Samantha': '사만다', 'Katherine': '캐서린', 'Rebecca': '레베카',
    'Victoria': '빅토리아', 'Christina': '크리스티나', 'Emma': '엠마', 'Olivia': '올리비아'
  }
};
export const spanishNamePronunciation: Record<string, Record<string, string>> = {
  male: {
    'Carlos': '카로로스', 'Miguel': '미겔', 'Diego': '디에고', 'Javier': '하비에르',
    'Luis': '루이스', 'Pablo': '파블로', 'Fernando': '페르난도', 'Alejandro': '알레한드로',
    'Antonio': '안토니오', 'Manuel': '마누엘', 'Francisco': '프란시스코', 'Rafael': '라파엘',
    'Pedro': '페드로', 'Jose': '호세', 'Juan': '후안', 'Sergio': '세르히오',
    'Andres': '안드레스', 'Ricardo': '리카르도', 'Eduardo': '에두아르도', 'Roberto': '로베르토'
  },
  female: {
    'Maria': '마리아', 'Carmen': '카르멘', 'Sofia': '소피아', 'Isabella': '이사벨라',
    'Lucia': '루시아', 'Elena': '엘레나', 'Ana': '아나', 'Valentina': '발렌티나',
    'Camila': '카밀라', 'Gabriela': '가브리엘라', 'Daniela': '다니엘라', 'Paula': '파울라',
    'Laura': '라우라', 'Andrea': '안드레아', 'Natalia': '나탈리아', 'Sara': '사라',
    'Julia': '줄리아', 'Adriana': '아드리아나', 'Alejandra': '알레한드라', 'Carolina': '카롤리나'
  }
};
export const frenchNamePronunciation: Record<string, Record<string, string>> = {
  male: {
    'Pierre': '피에르', 'Jean': '장', 'Louis': '루이', 'Antoine': '앙투안',
    'Nicolas': '니콜라', 'Alexandre': '알렉상드르', 'Thomas': '토마', 'Lucas': '루카',
    'Julien': '줄리앙', 'Maxime': '막심', 'Clement': '클레멍', 'Hugo': '위고',
    'Mathieu': '마티외', 'Romain': '로망', 'Sebastien': '세바스티앙', 'Vincent': '뱅상',
    'Olivier': '올리비에', 'Laurent': '로랑', 'Philippe': '필립', 'Francois': '프랑수아'
  },
  female: {
    'Marie': '마리', 'Sophie': '소피', 'Camille': '카밀', 'Emma': '엠마',
    'Lea': '레아', 'Chloe': '클로에', 'Julie': '줄리', 'Charlotte': '샤를로트',
    'Manon': '마농', 'Laura': '로라', 'Sarah': '사라', 'Pauline': '폴린',
    'Claire': '클레르', 'Oceane': '오세안', 'Marine': '마린', 'Anais': '아나이스',
    'Mathilde': '마티드', 'Juliette': '줄리에트', 'Emilie': '에밀리', 'Celine': '셀린'
  }
};
export const germanNamePronunciation: Record<string, Record<string, string>> = {
  male: {
    'Hans': '한스', 'Klaus': '클라우스', 'Wolfgang': '볼프강', 'Dieter': '디터',
    'Jurgen': '위르겐', 'Michael': '미하엘', 'Thomas': '토마스', 'Andreas': '안드레아스',
    'Peter': '페터', 'Stefan': '슈테판', 'Christian': '크리스티안', 'Markus': '마르쿠스',
    'Martin': '마르틴', 'Daniel': '다니엘', 'Sebastian': '제바스티안', 'Alexander': '알렉산더',
    'Matthias': '마티아스', 'Florian': '플로리안', 'Tobias': '토비아스', 'Lukas': '루카스'
  },
  female: {
    'Anna': '안나', 'Emma': '엠마', 'Sophie': '조피', 'Marie': '마리',
    'Laura': '라우라', 'Lena': '레나', 'Julia': '율리아', 'Hannah': '한나',
    'Lea': '레아', 'Sarah': '자라', 'Lisa': '리자', 'Katharina': '카타리나',
    'Nina': '니나', 'Jana': '야나', 'Melanie': '멜라니', 'Sandra': '잔드라',
    'Christina': '크리스티나', 'Stefanie': '슈테파니', 'Andrea': '안드레', 'Petra': '페트라'
  }
};
export const arabicNamePronunciation: Record<string, Record<string, string>> = {
  male: {
    'Ahmed': '아흐메드', 'Mohammed': '무함마드', 'Omar': '오마르', 'Ali': '알리',
    'Hassan': '하산', 'Khalid': '칼리드', 'Youssef': '유세프', 'Karim': '카림',
    'Abdullah': '압둘라', 'Ibrahim': '이브라힘', 'Mahmoud': '마흐무드', 'Mustafa': '무스타파',
    'Tariq': '타리크', 'Samir': '사미르', 'Rashid': '라시드', 'Faisal': '파이살',
    'Hamza': '함자', 'Jamal': '자말', 'Nabil': '나빌', 'Rami': '라미'
  },
  female: {
    'Fatima': '파티마', 'Aisha': '아이샤', 'Layla': '레일라', 'Noor': '누르',
    'Amira': '아미라', 'Yasmin': '야스민', 'Zara': '자라', 'Salma': '살마',
    'Mariam': '마리암', 'Hana': '하나', 'Leila': '레일라', 'Rania': '라니아',
    'Sara': '사라', 'Dina': '디나', 'Huda': '후다', 'Iman': '이만',
    'Jamila': '자밀라', 'Karima': '카리마', 'Lina': '리나', 'Mona': '모나'
  }
};
export const portugueseNamePronunciation: Record<string, Record<string, string>> = {
  male: {
    'Joao': '주앙', 'Pedro': '페드루', 'Lucas': '루카스', 'Gabriel': '가브리엘',
    'Rafael': '하파엘', 'Miguel': '미겔', 'Bruno': '브루누', 'Andre': '안드레',
    'Tiago': '티아구', 'Diogo': '디오구', 'Rodrigo': '호드리구', 'Goncalo': '곤살루',
    'Francisco': '프란시스쿠', 'Bernardo': '베르나르두', 'Tomas': '토마스', 'Guilherme': '길레르미',
    'Mateus': '마테우스', 'Ricardo': '히카르두', 'Nuno': '누누', 'Rui': '후이'
  },
  female: {
    'Maria': '마리아', 'Ana': '아나', 'Sofia': '소피아', 'Isabella': '이자벨라',
    'Beatriz': '베아트리스', 'Carolina': '카롤리나', 'Juliana': '줄리아나', 'Camila': '카밀라',
    'Mariana': '마리아나', 'Gabriela': '가브리엘라', 'Larissa': '라리사', 'Fernanda': '페르난다',
    'Patricia': '파트리시아', 'Rafaela': '하파엘라', 'Vanessa': '바네사', 'Adriana': '아드리아나',
    'Bianca': '비앙카', 'Carla': '카를라', 'Daniela': '다니엘라', 'Elisa': '엘리자'
  }
};

export const koreanSurnamePronunciation: Record<string, string> = {
  'Kim': '킴', 'Lee': '리', 'Park': '팍', 'Choi': '최', 'Jung': '정',
  'Kang': '강', 'Cho': '조', 'Yoon': '윤', 'Jang': '장', 'Lim': '림',
  'Han': '한', 'Oh': '오', 'Seo': '서', 'Shin': '신', 'Kwon': '권',
  'Hwang': '황', 'Ahn': '안', 'Song': '송', 'Ryu': '류', 'Jeon': '전',
  'Hong': '홍', 'Ko': '코', 'Moon': '문', 'Yang': '양', 'Son': '손',
  'Bae': '배', 'Baek': '백', 'Heo': '허', 'Yoo': '유', 'Nam': '남',
  'Shim': '심', 'Noh': '노', 'Ha': '하', 'Kwak': '곽', 'Sung': '성',
  'Cha': '차', 'Joo': '주', 'Woo': '우', 'Koo': '구', 'Min': '민',
  'Na': '나', 'Jin': '진', 'Ji': '지', 'Eom': '엄', 'Chae': '채',
  'Won': '원', 'Cheon': '천', 'Bang': '방', 'Kong': '공', 'Hyun': '현',
  'Ham': '함', 'Byun': '변', 'Yeom': '염', 'Yeo': '여', 'Choo': '추',
  'Do': '도', 'So': '소', 'Seok': '석', 'Sun': '선', 'Seol': '설',
  'Ma': '마', 'Gil': '길', 'Yeon': '연', 'Wi': '위', 'Pyo': '표',
  'Myung': '명', 'Ki': '기', 'Ban': '반', 'Pi': '피', 'Wang': '왕',
  'Geum': '금', 'Ok': '옥', 'Yuk': '육', 'In': '인', 'Maeng': '맹',
  'Je': '제', 'Mo': '모', 'Tak': '탁', 'Kook': '국', 'Eo': '어',
  'Eun': '은', 'Pyeon': '편'
};

export const surnameMap: Record<string, string> = {
  '김': 'Kim', '이': 'Lee', '박': 'Park', '최': 'Choi', '정': 'Jung',
  '강': 'Kang', '조': 'Cho', '윤': 'Yoon', '장': 'Jang', '임': 'Lim',
  '한': 'Han', '오': 'Oh', '서': 'Seo', '신': 'Shin', '권': 'Kwon',
  '황': 'Hwang', '안': 'Ahn', '송': 'Song', '류': 'Ryu', '전': 'Jeon',
  '홍': 'Hong', '고': 'Ko', '문': 'Moon', '양': 'Yang', '손': 'Son',
  '배': 'Bae', '백': 'Baek', '허': 'Heo', '유': 'Yoo', '남': 'Nam',
  '심': 'Shim', '노': 'Noh', '하': 'Ha', '곽': 'Kwak', '성': 'Sung',
  '차': 'Cha', '주': 'Joo', '우': 'Woo', '구': 'Koo', '민': 'Min',
  '나': 'Na', '진': 'Jin', '지': 'Ji', '엄': 'Eom', '채': 'Chae',
  '원': 'Won', '천': 'Cheon', '방': 'Bang', '공': 'Kong', '현': 'Hyun',
  '함': 'Ham', '변': 'Byun', '염': 'Yeom', '여': 'Yeo', '추': 'Choo',
  '도': 'Do', '소': 'So', '석': 'Seok', '선': 'Sun', '설': 'Seol',
  '마': 'Ma', '길': 'Gil', '연': 'Yeon', '위': 'Wi', '표': 'Pyo',
  '명': 'Myung', '기': 'Ki', '반': 'Ban', '피': 'Pi', '왕': 'Wang',
  '금': 'Geum', '옥': 'Ok', '육': 'Yuk', '인': 'In', '맹': 'Maeng',
  '제': 'Je', '모': 'Mo', '탁': 'Tak', '국': 'Kook', '어': 'Eo',
  '은': 'Eun', '편': 'Pyeon'
};

export const maleNames: Record<string, string[]> = {
  japan: ['Haruto', 'Yuto', 'Sota', 'Kaito', 'Riku', 'Takumi', 'Ren', 'Daiki', 'Yuki', 'Hayato', 'Shota', 'Kenta', 'Ryota', 'Tatsuya', 'Kenji', 'Hiroshi', 'Masato', 'Naoki', 'Shinji', 'Akira'],
  china: ['Wei', 'Chen', 'Ming', 'Jun', 'Hao', 'Feng', 'Lei', 'Xin', 'Bo', 'Cheng', 'Dong', 'Gang', 'Guang', 'Hai', 'Jian', 'Kai', 'Lin', 'Long', 'Peng', 'Qiang'],
  english: ['James', 'Michael', 'David', 'John', 'Robert', 'William', 'Daniel', 'Matthew', 'Christopher', 'Andrew', 'Joseph', 'Ryan', 'Brandon', 'Jason', 'Justin', 'Kevin', 'Brian', 'Eric', 'Steven', 'Timothy'],
  spanish: ['Carlos', 'Miguel', 'Diego', 'Javier', 'Luis', 'Pablo', 'Fernando', 'Alejandro', 'Antonio', 'Manuel', 'Francisco', 'Rafael', 'Pedro', 'Jose', 'Juan', 'Sergio', 'Andres', 'Ricardo', 'Eduardo', 'Roberto'],
  french: ['Pierre', 'Jean', 'Louis', 'Antoine', 'Nicolas', 'Alexandre', 'Thomas', 'Lucas', 'Julien', 'Maxime', 'Clement', 'Hugo', 'Mathieu', 'Romain', 'Sebastien', 'Vincent', 'Olivier', 'Laurent', 'Philippe', 'Francois'],
  german: ['Hans', 'Klaus', 'Wolfgang', 'Dieter', 'Jurgen', 'Michael', 'Thomas', 'Andreas', 'Peter', 'Stefan', 'Christian', 'Markus', 'Martin', 'Daniel', 'Sebastian', 'Alexander', 'Matthias', 'Florian', 'Tobias', 'Lukas'],
  arabic: ['Ahmed', 'Mohammed', 'Omar', 'Ali', 'Hassan', 'Khalid', 'Youssef', 'Karim', 'Abdullah', 'Ibrahim', 'Mahmoud', 'Mustafa', 'Tariq', 'Samir', 'Rashid', 'Faisal', 'Hamza', 'Jamal', 'Nabil', 'Rami'],
  portuguese: ['Joao', 'Pedro', 'Lucas', 'Gabriel', 'Rafael', 'Miguel', 'Bruno', 'Andre', 'Tiago', 'Diogo', 'Rodrigo', 'Goncalo', 'Francisco', 'Bernardo', 'Tomas', 'Guilherme', 'Mateus', 'Ricardo', 'Nuno', 'Rui'],
  russian: ['Dmitri', 'Alexei', 'Ivan', 'Nikolai', 'Sergei', 'Mikhail', 'Pavel', 'Andrei', 'Vladimir', 'Konstantin', 'Yuri', 'Boris', 'Viktor', 'Maxim', 'Artem', 'Evgeny', 'Ilya', 'Roman', 'Oleg', 'Stanislav'],
  thai: ['Somchai', 'Kritsana', 'Nattapong', 'Chaiwat', 'Pongsakorn', 'Thanakorn', 'Wichai', 'Surachai', 'Kittipong', 'Narong', 'Prasert', 'Sompong', 'Theerawat', 'Worawit', 'Yuttapong', 'Chatchai', 'Dechawat', 'Ekachai', 'Fuengfah', 'Gritsada']
};

export const femaleNames: Record<string, string[]> = {
  japan: ['Sakura', 'Yui', 'Hina', 'Mio', 'Aoi', 'Rin', 'Mei', 'Yuna', 'Akari', 'Nanami', 'Ayaka', 'Emi', 'Haruka', 'Kana', 'Miyu', 'Nana', 'Riko', 'Saki', 'Yuki', 'Asuka'],
  china: ['Mei', 'Ling', 'Xiu', 'Yan', 'Li', 'Jing', 'Fang', 'Hui', 'Xia', 'Ying', 'Qing', 'Rong', 'Shu', 'Wen', 'Xin', 'Yu', 'Zhen', 'Ai', 'Bao', 'Chun'],
  english: ['Emily', 'Sarah', 'Jessica', 'Ashley', 'Jennifer', 'Amanda', 'Michelle', 'Rachel', 'Elizabeth', 'Megan', 'Lauren', 'Stephanie', 'Nicole', 'Samantha', 'Katherine', 'Rebecca', 'Victoria', 'Christina', 'Emma', 'Olivia'],
  spanish: ['Maria', 'Carmen', 'Sofia', 'Isabella', 'Lucia', 'Elena', 'Ana', 'Valentina', 'Camila', 'Gabriela', 'Daniela', 'Paula', 'Laura', 'Andrea', 'Natalia', 'Sara', 'Julia', 'Adriana', 'Alejandra', 'Carolina'],
  french: ['Marie', 'Sophie', 'Camille', 'Emma', 'Lea', 'Chloe', 'Julie', 'Charlotte', 'Manon', 'Laura', 'Sarah', 'Pauline', 'Claire', 'Oceane', 'Marine', 'Anais', 'Mathilde', 'Juliette', 'Emilie', 'Celine'],
  german: ['Anna', 'Emma', 'Sophie', 'Marie', 'Laura', 'Lena', 'Julia', 'Hannah', 'Lea', 'Sarah', 'Lisa', 'Katharina', 'Nina', 'Jana', 'Melanie', 'Sandra', 'Christina', 'Stefanie', 'Andrea', 'Petra'],
  arabic: ['Fatima', 'Aisha', 'Layla', 'Noor', 'Amira', 'Yasmin', 'Zara', 'Salma', 'Mariam', 'Hana', 'Leila', 'Rania', 'Sara', 'Dina', 'Huda', 'Iman', 'Jamila', 'Karima', 'Lina', 'Mona'],
  portuguese: ['Maria', 'Ana', 'Sofia', 'Isabella', 'Beatriz', 'Carolina', 'Juliana', 'Camila', 'Mariana', 'Gabriela', 'Larissa', 'Fernanda', 'Patricia', 'Rafaela', 'Vanessa', 'Adriana', 'Bianca', 'Carla', 'Daniela', 'Elisa'],
  russian: ['Natasha', 'Olga', 'Irina', 'Tatiana', 'Elena', 'Anastasia', 'Ekaterina', 'Svetlana', 'Yulia', 'Oksana', 'Nadia', 'Vera', 'Galina', 'Larisa', 'Marina', 'Inna', 'Lyudmila', 'Valentina', 'Yelena', 'Daria'],
  thai: ['Nattaya', 'Kanya', 'Siriporn', 'Malee', 'Pornpan', 'Suda', 'Wanida', 'Ratana', 'Pensri', 'Duangjai', 'Anchana', 'Buppha', 'Chanya', 'Darunee', 'Fon', 'Ganya', 'Hathai', 'Jintana', 'Kannika', 'Lalita']
};

export const russianNamePronunciation: Record<string, Record<string, string>> = {
  male: {
    'Dmitri': '드미트리', 'Alexei': '알렉세이', 'Ivan': '이반', 'Nikolai': '니콜라이',
    'Sergei': '세르게이', 'Mikhail': '미하일', 'Pavel': '파벨', 'Andrei': '안드레이',
    'Vladimir': '블라디미르', 'Konstantin': '콘스탄틴', 'Yuri': '유리', 'Boris': '보리스',
    'Viktor': '빅토르', 'Maxim': '막심', 'Artem': '아르tem', 'Evgeny': '예브게니',
    'Ilya': '일리야', 'Roman': '로만', 'Oleg': '올레그', 'Stanislav': '스타니슬라프'
  },
  female: {
    'Natasha': '나타샤', 'Olga': '올가', 'Irina': '이리나', 'Tatiana': '타티아나',
    'Elena': '옐레나', 'Anastasia': '아나스타샤', 'Ekaterina': '예카테리나', 'Svetlana': '스베틠라나',
    'Yulia': '율리아', 'Oksana': '옥사나', 'Nadia': '나디아', 'Vera': '베라',
    'Galina': '갈리나', 'Larisa': '라리사', 'Marina': '마리나', 'Inna': '인나',
    'Lyudmila': '류드밀라', 'Valentina': '발렌티나', 'Yelena': '옐레나', 'Daria': '다리아'
  }
};

export const flagImageMap: Record<string, string> = {
  '일본': 'https://public.readdy.ai/ai/img_res/ee566f928fe94fd4c0494fcfbc2c418b.jpg',
  '중국': 'https://readdy.ai/api/search-image?query=Chinese%20flag%20with%20five%20stars%2C%20red%20and%20yellow%20colors%2C%20Great%20Wall%20silhouette%20background%2C%20traditional%20Chinese%20architecture%2C%20golden%20hour%20lighting%2C%20majestic%20atmosphere%2C%20high%20quality%20photography%2C%20wide%20angle%20view&width=400&height=300&seq=flag-china-001&orientation=landscape',
  '미국': 'https://readdy.ai/api/search-image?query=American%20flag%20stars%20and%20stripes%2C%20red%20white%20blue%20colors%2C%20Statue%20of%20Liberty%20silhouette%2C%20New%20York%20skyline%20background%2C%20patriotic%20atmosphere%2C%20sunset%20golden%20light%2C%20high%20quality%20photography%2C%20cinematic%20composition&width=400&height=300&seq=flag-usa-001&orientation=landscape',
  '스페인': 'https://readdy.ai/api/search-image?query=Spanish%20flag%20red%20and%20yellow%20stripes%2C%20royal%20coat%20of%20arms%2C%20Sagrada%20Familia%20silhouette%2C%20Barcelona%20architecture%20background%2C%20warm%20Mediterranean%20light%2C%20vibrant%20atmosphere%2C%20high%20quality%20photography%2C%20wide%20view&width=400&height=300&seq=flag-spain-001&orientation=landscape',
  '프랑스': 'https://readdy.ai/api/search-image?query=French%20flag%20tricolor%20blue%20white%20red%2C%20Eiffel%20Tower%20silhouette%2C%20Paris%20cityscape%20background%2C%20romantic%20atmosphere%2C%20golden%20hour%20lighting%2C%20elegant%20composition%2C%20high%20quality%20photography%2C%20cinematic%20view&width=400&height=300&seq=flag-france-001&orientation=landscape',
  '독일': 'https://readdy.ai/api/search-image?query=German%20flag%20black%20red%20gold%20horizontal%20stripes%2C%20Brandenburg%20Gate%20silhouette%2C%20Berlin%20architecture%20background%2C%20modern%20European%20atmosphere%2C%20clear%20daylight%2C%20high%20quality%20photography%2C%20wide%20angle%20composition&width=400&height=300&seq=flag-germany-001&orientation=landscape',
  '아랍': 'https://readdy.ai/api/search-image?query=Saudi%20Arabian%20flag%20green%20with%20white%20Arabic%20script%2C%20desert%20dunes%20background%2C%20mosque%20silhouette%2C%20Middle%20Eastern%20architecture%2C%20warm%20desert%20light%2C%20majestic%20atmosphere%2C%20high%20quality%20photography%2C%20cinematic%20composition&width=400&height=300&seq=flag-saudi-001&orientation=landscape',
  '브라질': 'https://readdy.ai/api/search-image?query=Brazilian%20flag%20green%20yellow%20blue%20with%20stars%2C%20Rio%20de%20Janeiro%20Christ%20the%20Redeemer%20statue%2C%20Copacabana%20beach%20background%2C%20tropical%20vibrant%20atmosphere%2C%20golden%20sunset%20light%2C%20high%20quality%20photography%2C%20cinematic%20wide%20angle%20view&width=400&height=300&seq=flag-brazil-001&orientation=landscape',
  '러시아': 'https://readdy.ai/api/search-image?query=Russian%20flag%20white%20blue%20red%20horizontal%20stripes%2C%20Saint%20Basil%20Cathedral%20colorful%20domes%2C%20Red%20Square%20Moscow%20background%2C%20winter%20snow%20atmosphere%2C%20dramatic%20sky%2C%20high%20quality%20photography%2C%20cinematic%20composition&width=400&height=300&seq=flag-russia-001&orientation=landscape',
  '태국': 'https://readdy.ai/api/search-image?query=Thai%20flag%20red%20white%20blue%20horizontal%20stripes%2C%20golden%20Buddhist%20temple%20Wat%20Phra%20Kaew%2C%20Bangkok%20skyline%20background%2C%20tropical%20warm%20light%2C%20majestic%20atmosphere%2C%20high%20quality%20photography%2C%20wide%20angle%20view&width=400&height=300&seq=flag-thailand-001&orientation=landscape'
};

export const thaiNamePronunciation: Record<string, Record<string, string>> = {
  male: {
    Somchai: '솜차이',
    Kritsana: '끄리싸나',
    Nattapong: 'нат타퐁',
    Chaiwat: '차이왓',
    Pongsakorn: '퐁사콘',
    Thanakorn: '타나콘',
    Wichai: '위차이',
    Surachai: '수라차이',
    Kittipong: '키티퐁',
    Narong: '나롱',
    Prasert: '프라세트',
    Sompong: '솜퐁',
    Theerawat: '티라와트',
    Worawit: '워라윗',
    Yuttapong: '윳타퐁',
    Chatchai: '차차이',
    Dechawat: '데차왓',
    Ekachai: '에카차이',
    Fuengfah: '프웨프파',
    Gritsada: '그리싸다',
  },
  female: {
    Nattaya: 'нат타야',
    Kanya: '칸야',
    Siriporn: '시리폰',
    Malee: '말리',
    Pornpan: '폰판',
    Suda: '수다',
    Wanida: '와니다',
    Ratana: '라타나',
    Pensri: '펜스리',
    Duangjai: '두앙자이',
    Anchana: '안차나',
    Buppha: '부프라',
    Chanya: '찬야',
    Darunee: '다루니',
    Fon: '폰',
    Ganya: '간야',
    Hathai: '하타이',
    Jintana: '진타나',
    Kannika: '칸니카',
    Lalita: '라리타',
  },
};

export const maleDescriptions: Record<string, string[]> = {
  japan: [
    '도쿄 긴자 갤러리의 현대미술 큐레이터',
    '교토 전통 도예 공방의 5대 장인',
    '오사카 미슐랭 2스타 레스토랑 수석 셰프',
    '후지산 등반 가이드 겸 산악 사진작가',
    '도쿄대 한국학과 교수',
    '닌텐도 게임 디자이너',
    '신칸센 수석 엔지니어',
    '도쿄 필하모닉 오케스트라 제1바이올리니스트'
  ],
  china: [
    '베이징 798 예술구 현대미술 갤러리 오너',
    '상하이 외탄 지구 5성급 호텔 총지배인',
    '실리콘밸리 출신 AI 스타트업 창업자',
    '만리장성 문화유산 보존 연구소 소장',
    '청두 판다 연구기지 수석 연구원',
    '항저우 차(茶) 문화 박물관 관장',
    '광저우 국제 무역 박람회 수석 통역사',
    '윈난성 소수민족 문화 다큐멘터리 감독'
  ],
  english: [
    '뉴욕 월스트리트 헤지펀드 매니저',
    '할리우드 영화 프로듀서',
    '실리콘밸리 구글 수석 엔지니어',
    '하버드 의대 교수 겸 외과 전문의',
    'NBA 시카고 불스 스포츠 에이전트',
    '워싱턴 D.C. 국무부 한반도 담당 외교관',
    '뉴욕 타임스 아시아 특파원',
    'NASA 우주비행사'
  ],
  spanish: [
    '바르셀로나 FC 축구 스카우터',
    '마드리드 프라도 미술관 큐레이터',
    '멕시코시티 타코 레스토랑 체인 오너',
    '부에노스아이레스 탱고 아카데미 원장',
    '마드리드 왕립 오페라 극장 테너 가수',
    '바르셀로나 건축 사무소 대표',
    '콜롬비아 커피 농장 오너',
    '세비야 플라멩코 무용단 단장'
  ],
  french: [
    '파리 루브르 박물관 동양미술 큐레이터',
    '파리 3스타 미슐랭 레스토랑 오너 셰프',
    '샤넬 파리 본사 수석 디자이너',
    '파리 오페라 발레단 수석 무용수',
    '칸 영화제 심사위원',
    '파리 소르본 대학 한국학과 교수',
    '에어프랑스 파리-서울 노선 수석 파일럿',
    '파리 패션위크 총감독'
  ],
  german: [
    '베를린 필하모닉 오케스트라 수석 지휘자',
    '뮌헨 BMW 수석 자동차 디자이너',
    '베를린 훔볼트 대학 한국학과 교수',
    '함부르크 항구 물류 회사 CEO',
    '프랑크푸르트 도이체방크 아시아 투자 담당 이사',
    '드레스덴 국립 오페라 극장 바리톤 가수',
    '베를린 스타트업 인큐베이터 대표',
    'munich 의대 신경과학 교수'
  ],
  arabic: [
    '두바이 버즈 칼리파 건설사 수석 엔지니어',
    '사우디아라비아 아람코 석유 회사 임원',
    '카타르 월드컵 경기장 설계 건축가',
    '아부다비 루브르 박물관 동양미술 큐레이터',
    '두바이 국제 금융 센터 투자 은행가',
    '이집트 카이로 대학 한국학과 교수',
    '모로코 마라케시 럭셔리 리조트 오너',
    '요르단 페트라 유적지 고고학 발굴 팀장'
  ],
  portuguese: [
    '리우데자네이루 카니발 삼바 스쿨 감독',
    '상파울루 브라질 국립 축구팀 피지컬 트레이너',
    '리스본 파두 음악 공연장 오너',
    '아마존 열대우림 생태 연구소 소장',
    '포르투 와인 소믈리에',
    '브라질리아 연방 의회 한국 담당 외교관',
    '상파울루 한인 타운 한국 식당 체인 오너',
    '리우 올림픽 조직위원회 출신 스포츠 컨설턴트'
  ],
  russian: [
    '볼쇼이 극장 수석 발레 안무가',
    '모스크바 국립대 물리학과 교수',
    '상트페테르부르크 에르미타주 박물관 동양미술 큐레이터',
    '러시아 국가대표 피겨 스케이팅 선수',
    '바이칼 호수 생태 연구소 수석 연구원',
    '모스크바 국제 영화제 프로그래머',
    '러시아 다이아몬드 광산 회사 임원',
    '모스크바 차이콥스키 음악원 피아노 교수',
    '상트페테르부르크 패션위크 스타 디자이너',
    '북극 탐험대 기후 연구원'
  ],
  thai: [
    '방콕 왓 포 사원 불교 문화 해설사',
    '치앙마이 코끼리 보호 구역 운영자',
    '방콕 미슐랭 레스토랑 수석 셰프',
    '푸켓 럭셔리 리조트 총지배인',
    '치앙라이 커피 농장 오너',
    '태국 전통 무용단 수석 무용수',
    '태국 왕실 전통 공예 장인',
    '방콕 국제 영화제 프로그래머',
    '파타야 수상 스포츠 센터 운영자',
    '치앙마이 전통 그림자 인형극 보존 협회장'
  ]
};

export const femaleDescriptions: Record<string, string[]> = {
  japan: [
    '도쿄 하라주쿠 패션 브랜드 크리에이티브 디렉터',
    '교토 전통 다도 학원 원장',
    '오사카 만화 출판사 편집장',
    '도쿄 국립 박물관 한국실 큐레이터',
    '후지TV 한류 전문 방송 PD',
    '도쿄 의대 피부과 전문의',
    '일본 국가대표 유도 코치',
    '도쿄 긴자 고급 화과자 장인'
  ],
  china: [
    '베이징 중앙미술학원 교수',
    '상하이 패션위크 수석 모델 에이전시 대표',
    '청두 판다 보호 연구소 수석 연구원',
    '항저우 알리바바 본사 한국 사업 담당 이사',
    '베이징 중앙음악학원 피아노 교수',
    '상하이 국제 영화제 프로그래머',
    '윈난성 소수민족 전통 의상 디자이너',
    '광저우 한방 의학 연구소 소장'
  ],
  english: [
    '뉴욕 메트로폴리탄 미술관 한국미술 큐레이터',
    '할리우드 배우 겸 영화 감독',
    '실리콘밸리 애플 수석 UX 디자이너',
    '하버드 의대 종양학과 교수',
    '뉴욕 패션위크 스타 디자이너',
    '워싱턴 D.C. 브루킹스 연구소 한반도 전문 연구원',
    '뉴욕 필하모닉 오케스트라 수석 첼리스트',
    'NASA 우주 생물학 연구원'
  ],
  spanish: [
    '마드리드 왕립 발레단 수석 무용수',
    '바르셀로나 패션 디자이너',
    '멕시코시티 국립 인류학 박물관 큐레이터',
    '부에노스아이레스 탱고 세계 챔피언',
    '마드리드 소피아 왕비 예술센터 현대미술 큐레이터',
    '바르셀로나 가우디 재단 연구원',
    '콜롬비아 보고타 국립대 한국학과 교수',
    '세비야 플라멩코 무용단 수석 무용수'
  ],
  french: [
    '파리 샤넬 본사 수석 향수 조향사',
    '파리 오페라 발레단 수석 발레리나',
    '파리 루브르 박물관 동양미술 큐레이터',
    '파리 패션위크 스타 모델',
    '칸 영화제 황금종려상 수상 감독',
    '파리 소르본 대학 한국학과 교수',
    '에르메스 파리 본사 수석 가죽 공예 장인',
    '파리 국립 음악원 성악과 교수'
  ],
  german: [
    '베를린 국립 오페라 극장 소프라노 가수',
    '뮌헨 BMW 디자인 센터 수석 인테리어 디자이너',
    '베를린 훔볼트 대학 한국학과 교수',
    '함부르크 국제 발레 콩쿠르 심사위원',
    '프랑크푸르트 도서 박람회 한국 담당 에디터',
    '드레스덴 국립 미술관 동양미술 큐레이터',
    '베를린 패션위크 스타 디자이너',
    'munich 의대 신경과학 교수'
  ],
  arabic: [
    '두바이 버즈 알 아랍 호텔 총지배인',
    '사우디아라비아 왕실 문화 재단 예술 감독',
    '카타르 알자지라 방송 한국 특파원',
    '아부다비 루브르 박물관 동양미술 큐레이터',
    '두바이 패션위크 스타 디자이너',
    '이집트 카이로 대학 한국학과 교수',
    '모로코 마라케시 전통 공예 장인',
    '요르단 암만 국제 영화제 프로그래머'
  ],
  portuguese: [
    '리우데자네이루 카니발 삼바 퀸',
    '상파울루 패션위크 스타 디자이너',
    '리스본 파두 가수',
    '아마존 열대우림 생태 연구소 수석 연구원',
    '포르투 와인 소믈리에',
    '브라질리아 연방 의회 한국 담당 외교관',
    '상파울루 한인 타운 한국 식당 체인 오너',
    '리우 올림픽 체조 국가대표 출신 코치'
  ],
  russian: [
    '볼쇼и 극장 수석 발레리на',
    '모스크바 국립대 물리학과 교수',
    '상트페테르부르크 에르미타ж 박물관 동양미술 큐레이터',
    '러시아 국가대표 피겨 스케이팅 선수',
    '바이칼 호수 생태 연구소 수석 연구원',
    '모스크바 국제 영화제 프로그래머',
    '러시아 다이아몬드 광산 회사 임원',
    '모스크바 차이코프스키 음악원 피아노 교수',
    '상트페테르부르크 패션위크 스타 디자이너',
    '북극 탐험대 기후 연구원'
  ],
  thai: [
    '방콕 왓 포 사원 불교 문화 해설사',
    '치앙마이 코끼리 보호 구역 운영자',
    '방콕 미슐랭 레스토랑 수석 셰프',
    '푸켓 럭셔리 리조트 총지배인',
    '치앙라이 커피 농장 오너',
    '태국 전통 무용단 수석 무용수',
    '태국 왕실 전통 공예 장인',
    '방콕 국제 영화제 프로그래머',
    '파타야 수상 스포츠 센터 운영자',
    '치앙마이 전통 그림자 인형극 보존 협회장'
  ]
};